module.exports = window.AMap;